<template>
    <div class="el-grid-card" style="width: 100%">
        <div class="el-grid-card__body">
            <el-row class="flex justify-between items-center filter-block">
                <div>
                    <el-date-picker
                        id="listDateTimeRange"
                        v-model="dateTimeRange"
                        @change="dateTimeRangeChange"
                        format="yyyy-MM-dd HH:mm"
                        type="datetimerange"
                        range-separator="-"
                        :clearable="false"
                        :start-placeholder="$t('form.label.dateTimeFrom')"
                        :end-placeholder="$t('form.label.dateTimeUntil')"
                        :picker-options="pickerOptions"
                        class="el-date-picker-light"
                    >
                    </el-date-picker>
                    <v-btn-toggle class="top-data-btn" v-model="activeButton">
                        <v-btn
                            flat
                            color="dark"
                            @click="fetchByDateTimeRange(withinDay)"
                        >
                            {{ $t('button.text.today') }}
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            @click="fetchByDateTimeRange(thisWeek)"
                            style="width: auto"
                        >
                            {{ $t('button.text.thisWeek', { number: 5 }) }}
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            @click="fetchByDateTimeRange(lastWeek)"
                            style="width: auto"
                        >
                            {{ $t('button.text.lastWeek', { number: 7 }) }}
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            @click="fetchByDateTimeRange(thisMonth)"
                            style="width: auto"
                        >
                            {{ $t('button.text.thisMonth', { number: 7 }) }}
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            @click="fetchByDateTimeRange(lastMonth)"
                            style="width: auto"
                        >
                            {{ $t('button.text.lastMonth', { number: 7 }) }}
                        </v-btn>
                        <v-btn
                            @click.prevent="() => downloadExcel()"
                            flat
                            color="dark"
                            style="width: auto"
                        >
                            {{ $t('button.text.downloadSelection') }}
                            <img
                                src="/images/icon/export-excel.png"
                                class="ml-1"
                                style="vertical-align: middle;"
                            />
                        </v-btn>
                    </v-btn-toggle>
                </div>
                <v-flex xs12 sm6 md3>
                    <v-container>
                        <v-layout row style="margin-bottom: 10px">
                            <el-checkbox
                                v-model="includeSubContainers"
                                @change="changeIncludeSubContainers"
                                :label="$t('table.column.includeSubContainers')"
                            ></el-checkbox>
                        </v-layout>
                        <v-layout row>
                            <div class="el-grid-card__filter-section-right">
                                <treeselect
                                    v-model="selectedContainers"
                                    value-format="object"
                                    class="top-multiselect"
                                    :multiple="true"
                                    :flat="isFlat"
                                    :value-consists-of="treeValueConsistsOf"
                                    :limit="treeLimit"
                                    :before-clear-all="handleBeforeClearAll"
                                    :placeholder="
                                        $t('form.label.selectContainers')
                                    "
                                    :options="containerTree"
                                    :normalizer="normalizer"
                                ></treeselect>
                            </div>
                        </v-layout>
                        <v-layout row style="margin-top: 10px">
                            <v-btn
                                v-if="isApplyBtnVisible"
                                round
                                color="blue"
                                dark
                                @click="onApply"
                            >
                                {{ $t('button.text.search') }}
                            </v-btn>
                            <v-btn
                                style="margin-left: 5px"
                                round
                                :class="filterSearchBtnCls"
                                dark
                                @click="openFilterSearch"
                            >
                                {{ $t('form.label.search') }}
                            </v-btn>
                        </v-layout>
                        <!--                        <v-layout row>-->
                        <!--                            <v-text-field-->
                        <!--                                :label="$t('form.label.search')"-->
                        <!--                                v-model="searchTerm"-->
                        <!--                                append-icon="search"-->
                        <!--                                class="el-light-search"-->
                        <!--                            ></v-text-field>-->
                        <!--                        </v-layout>-->
                    </v-container>
                </v-flex>
            </el-row>
            <el-row>
                <el-table
                    class="el-table__dark-expandable"
                    :data="filteredResults"
                    v-loading="loading"
                    ref="eventTable"
                    style="width: 100%"
                    border
                    :row-class-name="tableRowClassName"
                    @header-click="handleShowFilter"
                    @row-click="
                        row => {
                            rowClicked(row, $refs.eventTable)
                        }
                    "
                >
                    <el-table-column
                        :sortable="!filtersVisible"
                        :label="$t('table.column.dateTime')"
                        prop="EventDateTime"
                        :render-header="renderCustomHeader"
                    >
                        <template slot-scope="{ row }">
                            {{ row.EventDateTime | formatDateTime }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        :sortable="true"
                        :label="$t('table.column.direction')"
                        prop="Direction"
                        :render-header="renderCustomHeader"
                    >
                        <template slot-scope="{ row }">
                            {{ row.Direction }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        :sortable="true"
                        :label="$t('table.column.container')"
                        prop="DestinationContainerDescription"
                        :render-header="renderCustomHeader"
                    >
                        <template slot-scope="{ row }">
                            {{ row.DestinationContainerDescription }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        :sortable="true"
                        :label="$t('table.column.user')"
                        prop="UserFullName"
                        :render-header="renderCustomHeader"
                    >
                        <template slot-scope="{ row }">
                            {{ row.UserFullName }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        :sortable="true"
                        :label="$t('table.column.recipientName')"
                        prop="RecipientName"
                        :render-header="renderCustomHeader"
                    >
                        <template slot-scope="{ row }">
                            {{ row.RecipientName }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        :sortable="true"
                        :label="$t('table.column.where')"
                        prop="CheckpointName"
                        :render-header="renderCustomHeader"
                    >
                        <template slot-scope="{ row }">
                            {{ row.CheckpointName }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        :sortable="true"
                        :label="$t('table.column.bookingReference')"
                        prop="BookingReference"
                        :render-header="renderCustomHeader"
                    >
                        <template slot-scope="{ row }">
                            {{ row.BookingReference }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        :sortable="true"
                        :label="$t('table.data.label.pinCode')"
                        prop="PinCode"
                        :render-header="renderCustomHeader"
                    >
                        <template slot-scope="{ row }">
                            {{ row.PinCode }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        :sortable="true"
                        :label="$t('table.column.bookingType')"
                        prop="ActorType"
                        :render-header="renderCustomHeader"
                    >
                        <template slot-scope="{ row }">
                            {{ row.ActorType }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        :sortable="true"
                        :label="$t('table.column.detailedAuthenticationResult')"
                        prop="DetailedAuthenticationResult"
                        :render-header="renderCustomHeader"
                    >
                        <template slot-scope="{ row }">
                            {{ row.DetailedAuthenticationResult }}
                        </template>
                    </el-table-column>

                    <el-table-column :resizable="false" type="expand">
                        <template slot-scope="{ row }">
                            <el-table
                                class="el-table__inner-editable"
                                style="width: 100%"
                                border
                                :data="row.EventToolData"
                            >
                                <el-table-column
                                    width="450"
                                    :label="
                                        $t('table.column.authenticationMethod')
                                    "
                                    prop="AuthenticationMethod"
                                >
                                </el-table-column>

                                <el-table-column
                                    width="450"
                                    :label="$t('table.column.plateNo')"
                                >
                                    <template slot-scope="{ row }">
                                        <plates-component
                                            :row="row"
                                        ></plates-component>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :label="$t('table.column.reason')"
                                    prop="Reason"
                                >
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    :page-count="totalPages"
                    :total="totalCount"
                    :current-page="currentPage"
                    :page-sizes="[20, 30, 40, 50, 100, 500, 1000, 5000]"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    style="margin-top: 10px"
                >
                </el-pagination>
            </el-row>
        </div>

        <!-- Search Criteria Filter Slide Collapse -->
        <Slide
            right
            :isOpen="searchCriteriaOpenState"
            :burgerIcon="false"
            @closeMenu="searchCriteriaOpenState = false"
        >
            <div
                class="search-filter-box"
                @click="searchFilterComponentClick"
                style=" padding-top: 0; padding-bottom: 0; margin-bottom: 0; margin-top: 0; "
            >
                <h4 class="search-filter-header">
                    {{ $t('form.label.search') }}
                </h4>
            </div>
            <div
                class="search-filter-box"
                @click="searchFilterComponentClick"
                style=" padding-bottom: 0 !important; padding-top: 0 !important; "
            >
                <v-select
                    :items="['IN', 'OUT', 'UNKNOWN']"
                    :label="$t('table.column.direction')"
                    @input="filterSearchBtnColorChange($event)"
                    v-model="directionSearchFilter"
                    multiple
                    clearable
                    style="margin-bottom: -10px !important;"
                ></v-select>
            </div>
            <div
                class="search-filter-box"
                @click="searchFilterComponentClick"
                style=" padding-bottom: 0 !important; padding-top: 0 !important; margin-top: -10px;"
            >
                <v-select
                    :items="checkPoints"
                    item-text="Name"
                    :label="$t('table.column.where')"
                    @input="filterSearchBtnColorChange($event)"
                    v-model="whereSearchFilter"
                    multiple
                    clearable
                    style="margin-bottom: -10px !important;"
                ></v-select>
            </div>
            <div
                class="search-filter-box"
                @click="searchFilterComponentClick"
                style=" padding-bottom: 0 !important; padding-top: 0 !important; margin-top: -10px;"
            >
                <v-select
                    :items="['SLOT', 'PASS', 'STANDARD']"
                    :label="$t('table.column.bookingType')"
                    @input="filterSearchBtnColorChange($event)"
                    v-model="bookingTypeSearchFilter"
                    multiple
                    clearable
                    style="margin-bottom: -10px !important;"
                ></v-select>
            </div>
            <div
                class="search-filter-box"
                @click="searchFilterComponentClick"
                style=" padding-bottom: 0 !important; padding-top: 0 !important; margin-top: -10px;"
            >
                <v-select
                    :items="[
                        'ACCESS_GRANTED',
                        'ACCESS_DENIED_TAILGATE',
                        'ACCESS_DENIED_ERROR',
                        'ACCESS_DENIED_PLATE_NOT_FOUND',
                        'ACCESS_DENIED_PINCODE_NOT_FOUND',
                        'ACCESS_DENIED_NOT_IN_SCHEDULE',
                    ]"
                    :label="$t('table.column.detailedAuthenticationResult')"
                    @input="filterSearchBtnColorChange($event)"
                    v-model="detailedAuthenticationResultSearchFilter"
                    style="margin-bottom: -10px !important;"
                    multiple
                    clearable
                ></v-select>
            </div>
            <div
                class="search-filter-box"
                @click="searchFilterComponentClick"
                style=" padding-bottom: 0 !important; padding-top: 0 !important; margin-top: -10px;"
            >
                <v-select
                    :items="['PINREADER', 'MOBILE', 'LPR']"
                    :label="$t('table.column.authenticationMethod')"
                    @input="filterSearchBtnColorChange($event)"
                    v-model="authenticationMethodSearchFilter"
                    style="margin-bottom: -10px !important;"
                    multiple
                    clearable
                ></v-select>
            </div>
            <div class="search-filter-box" @click="searchFilterComponentClick">
                <v-text-field
                    style="margin-bottom: -35px !important;"
                    :label="$t('table.column.container')"
                    clearable
                    v-model="containerSearchFilter"
                    @change="filterSearchBtnColorChange($event)"
                ></v-text-field>
            </div>
            <div class="search-filter-box" @click="searchFilterComponentClick">
                <v-text-field
                    style="margin-bottom: -35px !important;"
                    :label="$t('table.column.user')"
                    clearable
                    v-model="userSearchFilter"
                    @change="filterSearchBtnColorChange($event)"
                ></v-text-field>
            </div>
            <div class="search-filter-box" @click="searchFilterComponentClick">
                <v-text-field
                    style="margin-bottom: -35px !important;"
                    :label="$t('table.column.recipientName')"
                    clearable
                    v-model="recipientNameSearchFilter"
                    @change="filterSearchBtnColorChange($event)"
                ></v-text-field>
            </div>
            <div class="search-filter-box" @click="searchFilterComponentClick">
                <v-text-field
                    style="margin-bottom: -35px !important;"
                    :label="$t('table.column.bookingReference')"
                    clearable
                    v-model="bookingReferenceSearchFilter"
                    @change="filterSearchBtnColorChange($event)"
                ></v-text-field>
            </div>
            <div class="search-filter-box" @click="searchFilterComponentClick">
                <v-text-field
                    style="margin-bottom: -35px !important;"
                    :label="$t('table.data.label.pinCode')"
                    clearable
                    v-model="pinCodeSearchFilter"
                    @change="filterSearchBtnColorChange($event)"
                ></v-text-field>
            </div>
            <div class="search-filter-box" @click="searchFilterComponentClick">
                <v-text-field
                    style="margin-bottom: -35px !important;"
                    :label="$t('table.column.plateNo')"
                    clearable
                    v-model="plateNoSearchFilter"
                    @change="filterSearchBtnColorChange($event)"
                ></v-text-field>
            </div>
            <div style="margin: 0px 0px 0px; !important;">
                <v-btn round color="blue" dark @click="searchWithFilters">
                    {{ $t('button.text.search') }}
                </v-btn>
                <v-btn
                    round
                    color="blue"
                    dark
                    @click="resetSearchCriteria"
                    style="margin-left: 5px"
                >
                    {{ $t('button.text.reset') }}
                </v-btn>
            </div>
        </Slide>
    </div>
</template>

<script>
import _ from 'lodash'
import FileSaver from 'file-saver'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import InteractWithDates from '../../mixins/interact-with-dates'
import LightBox from 'vue-image-lightbox'
import Treeselect from '@riophae/vue-treeselect'
import { Slide } from 'vue-burger-menu'
import Plates from './Plate'
import PlatesComponent from './PlatesComponent'

require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

export default {
    name: 'follow-up-list',

    mixins: [InteractWithDates],

    components: {
        PlatesComponent,
        Plates,
        LightBox,
        treeselect: Treeselect,
        Slide,
    },

    data() {
        return {
            activeButton: 0,
            treeLimit: 2,
            dateTimeRange: [],
            data: [],
            loading: false,
            downloading: false,
            searchTerm: '',
            searchObj: {},
            searchResults: [],
            filteredResults: [],
            selectedContainers: [],
            treeValueConsistsOf: 'ALL',
            includeSubContainers: false,
            isFlat: true,
            normalizer(node) {
                let data = {
                    id: node.ContainerID,
                    label: node.Description,
                }

                if (node.Children && node.Children.length) {
                    return {
                        ...data,
                        children: node.Children,
                    }
                }

                return data
            },
            isApplyBtnVisible: false,
            filtersVisible: false,
            totalPages: 1,
            currentPage: 1,
            totalCount: 0,
            pageSize: 20,
            currentPlateImage: '',
            selectedCandidateId: '',
            searchCriteriaOpenState: false,
            directionSearchFilter: '',
            containerSearchFilter: '',
            userSearchFilter: '',
            recipientNameSearchFilter: '',
            whereSearchFilter: '',
            bookingReferenceSearchFilter: '',
            pinCodeSearchFilter: '',
            plateNoSearchFilter: '',
            bookingTypeSearchFilter: '',
            detailedAuthenticationResultSearchFilter: '',
            authenticationMethodSearchFilter: '',
            filterSearchBtnCls: 'filter-search-btn-color',
            checkPoints: [],
        }
    },

    computed: {
        ...mapGetters(['isBlc', 'selectedContainer', 'containerTree']),

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },

        searchOptions() {
            return {
                keys: [
                    'EventDateTime',
                    'Direction',
                    'DestinationContainerDescription',
                    'UserFullName',
                    'RecipientName',
                    'CheckpointName',
                    'BookingReference',
                    'ActorType',
                    'EventToolData.ActorType',
                    'EventToolData.AuthenticationMethod',
                    'EventToolData.DetailedAuthenticationResult',
                    'EventToolData.PlateNo',
                    'EventToolData.Reason',
                ],
            }
        },

        eventToolItems() {
            if (this.data) {
                return this.data.map(item => {
                    const EventToolData = [item]
                    return {
                        ...item,
                        EventToolData,
                    }
                })
            }
        },
    },

    watch: {
        selectedContainer: function(container) {
            if (this.withPermission) {
                this.redirectIfNotBlc()
            }
            this.fetch(container, this.dateTimeRange)
        },
        searchTerm: _.debounce(async function() {
            if (this.searchTerm !== '') {
                this.searchResults = await this.$search(
                    this.searchTerm,
                    this.eventToolItems,
                    this.searchOptions
                )
            } else {
                this.searchResults = this.eventToolItems
            }
        }, 500),
        selectedContainers: function() {
            this.isApplyBtnVisible =
                this.selectedContainers && this.selectedContainers.length > 0
        },
        totalItems: function() {
            const arr = [
                ...this.selectedContainers.map(
                    container => container.ContainerID
                ),
            ]
            this.totalItems = arr.length
        },
    },

    created() {
        this.redirectIfNotBlc()
        this.selectedContainers = [this.selectedContainer]
        this.dateTimeRange = this.withinDay
        this.getCheckPoints()
    },

    methods: {
        openFilterSearch() {
            setTimeout(() => {
                this.$nextTick(() => {
                    this.searchCriteriaOpenState = !this.searchCriteriaOpenState
                })
            }, 10)
        },
        async getCheckPoints() {
            let { data } = await this.$http.get(`Checkpoint`)
            data.sort( (a, b) => {
                if(a && b && a.Name && b.Name){
                    return a.Name.localeCompare(b.Name, 'en', {numeric: true})
                }          
            });
            this.checkPoints = data
        },
        tableRowClassName({ row }) {
            if (row.AuthenticationResult === 'ACCESS_DENIED') {
                return 'table-row-red'
            } else if (row.AuthenticationResult === 'ACCESS_GRANTED') {
                return 'table-row-green1'
            } else if (row.AuthenticationResult === '') {
                return 'table-row-green2'
            } else {
                return ''
            }
        },

        handleShowFilter(column) {
            if (column.type === 'expand') {
                this.filtersVisible = !this.filtersVisible
            }
        },

        renderCustomHeader(h, { column }) {
            // const self = this
            return h('div', { class: 'el-custom-header' }, [
                h('p', { class: 'el-custom-header__title' }, column.label),
                // h('el-input', {
                //     class: `el-custom-header__details ${
                //         !this.filtersVisible ? 'hidden' : ''
                //     }`,
                //     props: { size: 'mini' },
                //     style: 'font-weight: normal',
                //     on: {
                //         input(e) {
                //             self.filterEventTools(column.label, e)
                //         },
                //     },
                // }),
            ])
        },

        filterEventTools(column, value) {
            let selectedColumn
            switch (column) {
                case this.$i18n.i18next.t('table.column.dateTime'):
                    selectedColumn = 'EventDateTime'
                    break
                case this.$i18n.i18next.t('table.column.direction'):
                    selectedColumn = 'Direction'
                    break
                case this.$i18n.i18next.t('table.column.container'):
                    selectedColumn = 'DestinationContainerDescription'
                    break
                case this.$i18n.i18next.t('table.column.user'):
                    selectedColumn = 'UserFullName'
                    break
                case this.$i18n.i18next.t('table.column.recipientName'):
                    selectedColumn = 'RecipientName'
                    break
                case this.$i18n.i18next.t('table.column.where'):
                    selectedColumn = 'CheckpointName'
                    break
                case this.$i18n.i18next.t('table.column.bookingReference'):
                    selectedColumn = 'BookingReference'
                    break
                case this.$i18n.i18next.t('table.data.label.pinCode'):
                    selectedColumn = 'PinCode'
                    break
                case this.$i18n.i18next.t('table.column.bookingType'):
                    selectedColumn = 'ActorType'
                    break
                case this.$i18n.i18next.t(
                    'table.column.detailedAuthenticationResult'
                ):
                    selectedColumn = 'DetailedAuthenticationResult'
                    break
            }
            this.searchObj = []
            this.searchObj[selectedColumn] = value
            this.handleSearch()
        },

        handleSearch() {
            if (!_.isEmpty(this.searchResults)) {
                this.filteredResults = this.searchResults
                this.filteredResults = this.searchResults.filter(item => {
                    for (let key in this.searchObj) {
                        if (this.searchObj[key]) {
                            if (item[key]) {
                                if (
                                    item[key]
                                        .toLowerCase()
                                        .includes(
                                            this.searchObj[key].toLowerCase()
                                        )
                                ) {
                                    return true
                                } else {
                                    return false
                                }
                            } else {
                                return false
                            }
                        } else {
                            return true
                        }
                    }
                })
            }
        },

        changeIncludeSubContainers() {
            // let currentSelectedContainers = this.selectedContainers;
            if (this.includeSubContainers) {
                this.selectedContainers = null
                setTimeout(
                    function() {
                        this.isFlat = false
                        // this.selectedContainers = currentSelectedContainers
                        this.isFlat = false
                    }.bind(this),
                    1000
                )
            } else {
                this.selectedContainers = null
                setTimeout(
                    function() {
                        this.isFlat = true
                        // this.selectedContainers = currentSelectedContainers
                    }.bind(this),
                    1000
                )
            }
        },

        rowClicked(row, table) {
            this.$nextTick(() => {
                if (this.downloading) return
                table.toggleRowExpansion(row)
            })
        },

        redirectIfNotBlc() {
            if (!this.isBlc) {
                this.$router.push({ name: 'dashboard' })
            }
        },

        fetchByDateTimeRange(range) {
            this.dateTimeRange = range
            this.isApplyBtnVisible = true
            if (this.selectedContainers.length === 0) {
                this.selectedContainers = [this.selectedContainer]
            }
        },
        async fetch(container = null, range = [], loading = true) {
            this.searchTerm = ''
            this.loading = loading

            container = container ? container : this.selectedContainer

            if (!_.isEmpty(container)) {
                range = range.length ? range : this.withinDay

                let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

                let dateTimeFrom = DateTime.fromISO(range[0].toISOString())
                let dateTimeTo = DateTime.fromISO(range[1].toISOString())

                // set end and start time to day start and day end if it doesn't contains time
                if (
                    dateTimeFrom.startOf('day').valueOf() ===
                        dateTimeFrom.valueOf() &&
                    dateTimeTo.startOf('day').valueOf() === dateTimeTo.valueOf()
                ) {
                    let start = dateTimeFrom.startOf('day')
                    let end = dateTimeTo.endOf('day')

                    dateTimeFrom = start.toFormat(dateTimeFormat)
                    dateTimeTo = end.toFormat(dateTimeFormat)

                    range = [start.toJSDate(), end.toJSDate()]
                } else {
                    dateTimeFrom = dateTimeFrom.toFormat(dateTimeFormat)
                    dateTimeTo = dateTimeTo.toFormat(dateTimeFormat)
                }

                let requestObj = {
                    DateTimeFrom: dateTimeFrom,
                    DateTimeTo: dateTimeTo,
                    ContainerFilter: [
                        ...this.selectedContainers.map(
                            container => container.ContainerID
                        ),
                    ],
                    CurrentPage: this.currentPage,
                    PageSize: this.pageSize,
                }

                if (this.pinCodeSearchFilter) {
                    requestObj.PinCode = this.pinCodeSearchFilter
                }
                if (this.plateNoSearchFilter) {
                    requestObj.PlateNo = this.plateNoSearchFilter
                }
                if (
                    this.directionSearchFilter &&
                    this.directionSearchFilter.length > 0
                ) {
                    requestObj.DirectionFilter = this.directionSearchFilter
                }
                if (this.containerSearchFilter) {
                    requestObj.DestinationContainerDescription = this.containerSearchFilter
                }
                if (this.userSearchFilter) {
                    requestObj.UserFullName = this.userSearchFilter
                }
                if (this.recipientNameSearchFilter) {
                    requestObj.RecipientName = this.recipientNameSearchFilter
                }
                if (
                    this.whereSearchFilter &&
                    this.whereSearchFilter.length > 0
                ) {
                    let whereArr = []
                    this.whereSearchFilter.map(data => {
                        whereArr.push(data.CheckpointID)
                    })
                    requestObj.CheckpointFilter = whereArr
                }
                if (this.bookingReferenceSearchFilter) {
                    requestObj.BookingReference = this.bookingReferenceSearchFilter
                }
                if (
                    this.bookingTypeSearchFilter &&
                    this.bookingTypeSearchFilter.length > 0
                ) {
                    requestObj.ActorTypeFilter = this.bookingTypeSearchFilter
                }
                if (
                    this.detailedAuthenticationResultSearchFilter &&
                    this.detailedAuthenticationResultSearchFilter.length > 0
                ) {
                    requestObj.DetailedAuthResutFilter = this.detailedAuthenticationResultSearchFilter
                }

                if (
                    this.authenticationMethodSearchFilter &&
                    this.authenticationMethodSearchFilter.length > 0
                ) {
                    requestObj.AuthMethodFilter = this.authenticationMethodSearchFilter
                }

                let { data } = await this.$http.post(
                    `AccessEvent/Search`,
                    requestObj
                )

                if (data && data.result) {
                    this.data = data.result
                    this.totalPages = data.TotalPages
                    this.currentPage = data.CurrentPage
                    this.totalCount = data.TotalCount
                    this.isApplyBtnVisible = false
                }

                this.searchResults = this.eventToolItems
                this.filteredResults = this.eventToolItems
                this.dateTimeRange = range
            }

            this.loading = false
        },

        openGallery(index, row) {
            const lightBox = `lightbox${row.ActorID}`

            this.$refs[lightBox].showImage(index)
        },

        async downloadExcel() {
            this.downloading = true

            let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

            let dateTimeFrom = DateTime.fromISO(
                this.dateTimeRange[0].toISOString()
            ).toFormat(dateTimeFormat)
            let dateTimeTo = DateTime.fromISO(
                this.dateTimeRange[1].toISOString()
            ).toFormat(dateTimeFormat)

            let requestObj = {
                DateTimeFrom: dateTimeFrom,
                DateTimeTo: dateTimeTo,
                ContainerFilter: [
                    ...this.selectedContainers.map(
                        container => container.ContainerID
                    ),
                ],
            }

            if (this.pinCodeSearchFilter) {
                requestObj.PinCode = this.pinCodeSearchFilter
            }
            if (this.plateNoSearchFilter) {
                requestObj.PlateNo = this.plateNoSearchFilter
            }
            if (
                this.directionSearchFilter &&
                this.directionSearchFilter.length > 0
            ) {
                requestObj.DirectionFilter = this.directionSearchFilter
            }
            if (this.containerSearchFilter) {
                requestObj.DestinationContainerDescription = this.containerSearchFilter
            }
            if (this.userSearchFilter) {
                requestObj.UserFullName = this.userSearchFilter
            }
            if (this.recipientNameSearchFilter) {
                requestObj.RecipientName = this.recipientNameSearchFilter
            }
            if (this.whereSearchFilter && this.whereSearchFilter.length > 0) {
                let whereArr = []
                this.whereSearchFilter.map(data => {
                    whereArr.push(data.CheckpointID)
                })
                requestObj.CheckpointFilter = whereArr
            }
            if (this.bookingReferenceSearchFilter) {
                requestObj.BookingReference = this.bookingReferenceSearchFilter
            }
            if (
                this.bookingTypeSearchFilter &&
                this.bookingTypeSearchFilter.length > 0
            ) {
                requestObj.ActorTypeFilter = this.bookingTypeSearchFilter
            }
            if (
                this.detailedAuthenticationResultSearchFilter &&
                this.detailedAuthenticationResultSearchFilter.length > 0
            ) {
                requestObj.DetailedAuthResutFilter = this.detailedAuthenticationResultSearchFilter
            }

            if (
                this.authenticationMethodSearchFilter &&
                this.authenticationMethodSearchFilter.length > 0
            ) {
                requestObj.AuthMethodFilter = this.authenticationMethodSearchFilter
            }

            let { data } = await this.$http.post(
                `AccessEvent/Search/Download`,
                requestObj,
                {
                    responseType: 'blob',
                }
            )

            FileSaver.saveAs(new Blob([data]), 'events.xlsx')

            this.downloading = false
        },

        async downloadExcelForRoute(row) {
            this.downloading = true

            const { data } = await this.$http.get(
                `/BLC/${this.selectedContainer.ContainerID}/Followupsheet/${
                    row.BLCRouteID
                }`,
                {
                    responseType: 'blob',
                }
            )
            FileSaver.saveAs(
                new Blob([data]),
                `followup-route-${row.Reference}.xlsx`
            )

            this.downloading = false
        },

        async downloadExcelForActor(row) {
            this.downloading = true

            const { data } = await this.$http.get(
                `/BLC/${this.selectedContainer.ContainerID}/Followupsheet/${
                    row.BLCRouteID
                }/Actor/${row.ActorID}`,
                {
                    responseType: 'blob',
                }
            )
            FileSaver.saveAs(
                new Blob([data]),
                `followup-actor-${row.Reference}.xlsx`
            )

            this.downloading = false
        },

        async downloadZipForRoute(row) {
            this.downloading = true

            const { data } = await this.$http.get(
                `/BLC/${row.BLCRouteID}/DownloadRouteImagesZip`,
                {
                    responseType: 'blob',
                }
            )
            FileSaver.saveAs(
                new Blob([data]),
                `followup-route-${row.Reference}.zip`
            )

            this.downloading = false
        },

        async downloadZipForActor(row) {
            this.downloading = true

            const { data } = await this.$http.get(
                `/BLC/${row.BLCRouteID}/DownloadRouteImagesZip/Actor/${
                    row.ActorID
                }`,
                {
                    responseType: 'blob',
                }
            )
            FileSaver.saveAs(
                new Blob([data]),
                `followup-actor-${row.Reference}.zip`
            )

            this.downloading = false
        },
        async handleBeforeClearAll() {
            try {
                await this.$confirm(
                    'Are you sure you want clear the fields?',
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )
                return true
            } catch (e) {
                return false
            }
        },

        onApply() {
            if (this.dateTimeRange) {
                this.fetchByDateTimeRange(this.dateTimeRange)
            } else {
                this.fetchByDateTimeRange(this.withinDay)
            }
            this.fetch(this.selectedContainer, this.dateTimeRange, true)
        },

        handleCurrentChange(val) {
            this.currentPage = val
            this.fetch(this.selectedContainer, this.dateTimeRange, true)
        },

        handleSizeChange(val) {
            this.pageSize = val
            this.fetch(this.selectedContainer, this.dateTimeRange, true)
        },

        dateTimeRangeChange(range) {
            this.activeButton = ''
            this.fetchByDateTimeRange(range)
        },
        resetSearchCriteria(e) {
            e.stopPropagation()
            this.containerSearchFilter = ''
            this.userSearchFilter = ''
            this.recipientNameSearchFilter = ''
            this.bookingReferenceSearchFilter = ''
            this.pinCodeSearchFilter = ''
            this.plateNoSearchFilter = ''
            this.filterSearchBtnCls = 'filter-search-btn-color'
            this.$nextTick(() => {
                this.directionSearchFilter = []
                this.whereSearchFilter = []
                this.bookingTypeSearchFilter = []
                this.detailedAuthenticationResultSearchFilter = []
                this.authenticationMethodSearchFilter = []
            })
        },
        searchWithFilters() {
            this.currentPage = 1
            this.onApply()
            this.searchCriteriaOpenState = false
        },
        searchFilterComponentClick(e) {
            if (
                !e.target.className ||
                e.target.className ===
                    'input-group input-group--placeholder input-group--text-field primary--text' ||
                e.target.className === 'search-filter-header' ||
                e.target.className === 'search-filter-box' ||
                e.target.className === 'search-filter-reset' ||
                e.target.className === 'input-group__selections' ||
                e.target.className === 'input-group__details' ||
                e.target.className === 'input-group__input' ||
                e.target.className ===
                    'input-group input-group--dirty input-group--text-field primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--dirty input-group--append-icon input-group--text-field input-group--select input-group--multiple primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--append-icon input-group--text-field input-group--select input-group--multiple primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--append-icon input-group--text-field input-group--select input-group--multiple input-group--open primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--dirty input-group--append-icon input-group--text-field input-group--select input-group--multiple input-group--open primary--text' ||
                e.target.className ===
                    'input-group input-group--text-field primary--text' ||
                e.target.className === 'input-group__selections__comma' ||
                e.target.className ===
                    'input-group input-group--focused input-group--append-icon input-group--text-field input-group--select primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--append-icon input-group--text-field input-group--select input-group--open primary--text' ||
                e.target.className ===
                    'input-group input-group--focused input-group--dirty input-group--append-icon input-group--text-field input-group--select primary--text'
            ) {
                e.stopPropagation()
            }
        },
        filterSearchBtnColorChange() {
            if (
                this.directionSearchFilter ||
                this.containerSearchFilter ||
                this.userSearchFilter ||
                this.recipientNameSearchFilter ||
                this.whereSearchFilter ||
                this.bookingReferenceSearchFilter ||
                this.pinCodeSearchFilter ||
                this.plateNoSearchFilter ||
                this.bookingTypeSearchFilter ||
                this.detailedAuthenticationResultSearchFilter ||
                this.authenticationMethodSearchFilter
            ) {
                this.filterSearchBtnCls = 'filter-search-btn-color2'
            } else {
                this.filterSearchBtnCls = 'filter-search-btn-color'
            }
        },
    },

    filters: {
        hyphenize: function(value) {
            if (!value) return '-'
            return value
        },
    },
}
</script>

<style>
.table-row-red {
    background-color: #e9a3a3 !important;
}

.table-row-green1 {
    background-color: #a3e9b9 !important;
}

.table-row-green2 {
    background-color: #cdf1d9 !important;
}

.bm-menu {
    background-color: #374252 !important;
    /*top: 61px !important;*/
}

.search-filter-box {
    padding: 0 10px 10px 0;
}

.search-filter-box ::placeholder {
    color: #8a8a8a !important;
}

/*Removes expand icon in last column*/
th.el-table__expand-column {
    background: none !important;
    background-color: #6b7990 !important;
}

.caret-wrapper {
    right: -5px !important;
}

.filter-search-btn-color {
    background-color: #38a096 !important;
}

.filter-search-btn-color2 {
    background-color: #f9a825 !important;
}

.el-date-editor {
    width: 260px !important;
}

.bm-item-list {
    margin-top: -10px !important;
}
.input-group--text-field {
}
</style>
